import { useFormikContext } from 'formik'
import React from 'react'

import FormField from '@/components/FormField'

import { FormValues } from '@/screens/SignUp/types'

export const HAS_EXISTING_POLICY = {
  no: 'no',
  yes: 'yes',
}

/**
 * Reveals the privacy policy URL field only once the user answers "Yes" to
 * having an existing policy, and clears whatever they typed if they switch back
 * to "No" so a stale URL is never submitted.
 */
export default function ProductPolicyUrl() {
  const {
    values: { hasExistingPolicy }, setFieldValue,
  } = useFormikContext<FormValues>()

  const hasPolicy = hasExistingPolicy === HAS_EXISTING_POLICY.yes

  React.useEffect(() => {
    if (setFieldValue && !hasPolicy) {
      setFieldValue('policyUrl', '')
    }
  }, [
    hasPolicy,
    setFieldValue,
  ])

  if (!hasPolicy) {
    // eslint-disable-next-line no-null/no-null
    return null
  }

  return (
    <FormField
      name='policyUrl'
      label='Privacy Policy URL'
      variant='outlined'
      type='text'
      inputProps={{ 'data-testid': 'signup-policy-url' }}
    />
  )
}
